import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]


export default /*#__PURE__*/_defineComponent({
  __name: 'CErrorModal',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const emit = __emit

return (_ctx: any,_cache: any) => {
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_t_text = _resolveComponent("t-text")!
  const _component_modal_content = _resolveComponent("modal-content")!
  const _component_t_button = _resolveComponent("t-button")!
  const _component_modal_actions = _resolveComponent("modal-actions")!
  const _component_modal_layout = _resolveComponent("modal-layout")!
  const _component_modal_app = _resolveComponent("modal-app")!
  const _component_gd_modal = _resolveComponent("gd-modal")!

  return (_openBlock(), _createBlock(_component_gd_modal, {
    class: "error-modal",
    "data-qe-id": "error-modal"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_modal_app, { s: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_modal_layout, null, {
            default: _withCtx(() => [
              _createVNode(_component_modal_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('errorView.main.title')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_modal_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_t_text, null, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "default")
                    ]),
                    _: 3
                  }),
                  _createElementVNode("img", {
                    src: require('@/assets/error/error_asset.png'),
                    alt: "broken cards"
                  }, null, 8, _hoisted_1)
                ]),
                _: 3
              }),
              _createVNode(_component_modal_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_t_button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('errorView.main.button')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})